import { render } from "./OrderPages.vue?vue&type=template&id=f6a6d454&scoped=true"
import script from "./OrderPages.vue?vue&type=script&lang=js"
export * from "./OrderPages.vue?vue&type=script&lang=js"

import "../../../../reports/css/modal.css?vue&type=style&index=0&id=f6a6d454&scoped=true&lang=css"
import "./OrderPages.vue?vue&type=style&index=1&id=f6a6d454&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a6d454"]])

export default __exports__